module.exports = __webpack_public_path__ + "img/c3.058e7ab8.png";